<div class="dropzone" [class.active]="isDragging">
    <input 
      type="file" 
      #fileInput
      class="file-input" 
      (change)="onFileInputChange($event)" 
      [multiple]="true"
      [accept]="acceptedFileTypes.join(',')"
    >
    
    <div class="dropzone-content">
      <div class="upload-img">
        
        <div class="upload-bg">
            <img class="upload-item item-1" src="assets/upload-line-item.png" alt="Upload Icon">
            <div class="spacer-15"></div>
            <img class="upload-item item-2" src="assets/upload-line-item.png" alt="Upload Icon">
        </div>

      </div>
      <h3>Drag and drop files here</h3>
      <p>or</p>
      <button type="button" class="btn btn-primary browse-btn" (click)="fileInput.click()">Browse Files</button>
      <p class="file-info" *ngIf="acceptedFileTypes.length > 0">
        Accepted file types: {{ acceptedFileTypes.join(', ') }}
      </p>
      <p class="file-info">
        Maximum file size: {{ maxFileSize }}MB
      </p>
      <p class="file-info note">
        <strong>Note:</strong> While you can upload any file type, AI processing is only available for: PDF, Word (DOCX), Excel (XLSX/XLS), CSV, and text files. Other formats will be stored but not parsed.
      </p>
    </div>
    
    <div class="error-container" *ngIf="errors.length > 0">
      <div class="error" *ngFor="let error of errors">{{ error }}</div>
    </div>
  </div>
